interface Certificate {
  number: string;
  name: string;
  date: string;
  StudyLevel?: string;
  category: string;
  Note?: string;
}

export const certificates: Certificate[] = [
  {
    number: "103/IITC/X/2024",
    name: "Raphael Kenzhou Pranoto",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Python Coding",
    Note: "1st Winner of Coding Junior Competition",
  },
  {
    number: "100/IITC/X/2024",
    name: "Jefferson Matthew Adidjaja",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Python Coding",
    Note: "2nd Winner of Coding Junior Competition",
  },
  {
    number: "108/IITC/X/2024",
    name: "Samuel Keith Lianto",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Python Coding",
    Note: "3rd Winner of Coding Junior Competition",
  },
  {
    number: "84/IITC/X/2024",
    name: "Matthew Joshua Hartono",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Python Coding",
    Note: "1st Winner of Coding Senior Competition",
  },
  {
    number: "85/IITC/X/2024",
    name: "Farisi Achmad Al-Banna",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Python Coding",
    Note: "2nd Winner of Coding Senior Competition",
  },
  {
    number: "79/IITC/X/2024",
    name: "Darell Joaqim Triman Hasugian",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Python Coding",
    Note: "3rd Winner of Coding Senior Competition",
  },
  //Student Symposium
  {
    number: "37/IITC/X/2024",
    name: "Marvino Aloysius Tjondro",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Student Symposium",
    Note: "1st Winner Of Student Symposium Competition",
  },
  {
    number: "37/IITC/X/2024",
    name: "Yehezkiel Michael Laysander",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Student Symposium",
    Note: "1st Winner Of Student Symposium Competition",
  },
  {
    number: "35/IITC/X/2024",
    name: "Nathan Alexander Lim",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Student Symposium",
    Note: "2nd Winner Of Student Symposium Competition",
  },
  {
    number: "35/IITC/X/2024",
    name: "Davien Erwin Ignatius",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Student Symposium",
    Note: "2nd Winner Of Student Symposium Competition",
  },
  {
    number: "35/IITC/X/2024",
    name: "Rayden Immanuel Setiawan",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Student Symposium",
    Note: "2nd Winner Of Student Symposium Competition",
  },
  {
    number: "35/IITC/X/2024",
    name: "Christopher Hansel",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Student Symposium",
    Note: "2nd Winner Of Student Symposium Competition",
  },

  {
    number: "39/IITC/X/2024",
    name: "Muhammad Abufadhl Abbas",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Student Symposium",
    Note: "3rd Winner Of Student Symposium Competition",
  },
  {
    number: "39/IITC/X/2024",
    name: "Zahwa Aqilah Mu'Tazzah",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Student Symposium",
    Note: "3rd Winner Of Student Symposium Competition",
  },
  {
    number: "39/IITC/X/2024",
    name: "Gina Mahrin Ratifah",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Student Symposium",
    Note: "3rd Winner Of Student Symposium Competition",
  },
  {
    number: "39/IITC/X/2024",
    name: "Ahmad Bayu",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Student Symposium",
    Note: "3rd Winner Of Student Symposium Competition",
  },
  //Innovative Technology
  {
    number: "42/IITC/X/2024",
    name: "Arleen Eleanor Shilton",
    date: "2024-10-27",
    StudyLevel: "SD",
    category: "Innovative Technology",
    Note: "1st Winner Of Innovative Junior Competition",
  },
  {
    number: "42/IITC/X/2024",
    name: "Aurelia Hojaya",
    date: "2024-10-27",
    StudyLevel: "SD",
    category: "Innovative Technology",
    Note: "1st Winner Of Innovative Junior Competition",
  },
  {
    number: "42/IITC/X/2024",
    name: "Michael Gerald Gouwtama",
    date: "2024-10-27",
    StudyLevel: "SD",
    category: "Innovative Technology",
    Note: "1st Winner Of Innovative Junior Competition",
  },
  {
    number: "42/IITC/X/2024",
    name: "Sidney Anyelir Simatupang",
    date: "2024-10-27",
    StudyLevel: "SD",
    category: "Innovative Technology",
    Note: "1st Winner Of Innovative Junior Competition",
  },
  {
    number: "46/IITC/X/2024",
    name: "Quentin Witio",
    date: "2024-10-27",
    StudyLevel: "SD",
    category: "Innovative Technology",
    Note: "2nd Winner Of Innovative Junior Competition",
  },
  {
    number: "46/IITC/X/2024",
    name: "Louis Josiah Gosal",
    date: "2024-10-27",
    StudyLevel: "SD",
    category: "Innovative Technology",
    Note: "2nd Winner Of Innovative Junior Competition",
  },
  {
    number: "46/IITC/X/2024",
    name: "Shayden Jade Antony",
    date: "2024-10-27",
    StudyLevel: "SD",
    category: "Innovative Technology",
    Note: "2nd Winner Of Innovative Junior Competition",
  },
  {
    number: "44/IITC/X/2024",
    name: "Joan Mulyadi",
    date: "2024-10-27",
    StudyLevel: "SD",
    category: "Innovative Technology",
    Note: "3rd Winner Of Innovative Junior Competition",
  },
  {
    number: "44/IITC/X/2024",
    name: "Landon Keandre Noveanto",
    date: "2024-10-27",
    StudyLevel: "SD",
    category: "Innovative Technology",
    Note: "3rd Winner Of Innovative Junior Competition",
  },
  {
    number: "44/IITC/X/2024",
    name: "Nicholas Irawan",
    date: "2024-10-27",
    StudyLevel: "SD",
    category: "Innovative Technology",
    Note: "3rd Winner Of Innovative Junior Competition",
  },
  {
    number: "53/IITC/X/2024",
    name: "Darrell Rayford Tjahjadi",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Innovative Technology",
    Note: "1st Winner Of Innovative Senior Competition",
  },
  {
    number: "53/IITC/X/2024",
    name: "Revand Jettha Raimun",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Innovative Technology",
    Note: "1st Winner Of Innovative Senior Competition",
  },
  {
    number: "51/IITC/X/2024",
    name: "Chester Adrian",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Innovative Technology",
    Note: "2nd Winner Of Innovative Senior Competition",
  },
  {
    number: "51/IITC/X/2024",
    name: "Josh Lemuel Alijaya",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Innovative Technology",
    Note: "2nd Winner Of Innovative Senior Competition",
  },
  {
    number: "61/IITC/X/2024",
    name: "Raditya Isham Habibi",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Innovative Technology",
    Note: "3rd Winner Of Innovative Senior Competition",
  },
  {
    number: "61/IITC/X/2024",
    name: "AzulGrana Kenzie Asadel Ramadhan",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Innovative Technology",
    Note: "3rd Winner Of Innovative Senior Competition",
  },
  {
    number: "61/IITC/X/2024",
    name: "Mu'thi Syamil Mumtaz",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Innovative Technology",
    Note: "3rd Winner Of Innovative Senior Competition",
  },
  //Obstacle
  {
    number: "06/IITC/X/2024",
    name: "Raynard Dickinson",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Obstacle Driving",
    Note: "1st Winner Of Obstacle Robot Competition",
  },
  {
    number: "06/IITC/X/2024",
    name: "Raphael Benedict Rustam",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Obstacle Driving",
    Note: "1st Winner Of Obstacle Robot Competition",
  },
  {
    number: "02/IITC/X/2024",
    name: "Anderson Andrew Chandra",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Obstacle Driving",
    Note: "2nd Winner Of Obstacle Robot Competition",
  },
  {
    number: "02/IITC/X/2024",
    name: "Dave Matthew Gunawan",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Obstacle Driving",
    Note: "2nd Winner Of Obstacle Robot Competition",
  },
  {
    number: "12/IITC/X/2024",
    name: "Rendyca Susandi Putra",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Obstacle Driving",
    Note: "3rd Winner Of Obstacle Robot Competition",
  },
  {
    number: "12/IITC/X/2024",
    name: "Raihan Baihaqqi",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Obstacle Driving",
    Note: "3rd Winner Of Obstacle Robot Competition",
  },
  //Sumo Game
  {
    number: "18/IITC/X/2024",
    name: "Gregorius Nathaniel Perdana Budihartono",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Sumo Robot",
    Note: "1st Winner Of Sumo Game Competition",
  },
  {
    number: "18/IITC/X/2024",
    name: "Edward Putera Rusli",
    date: "2024-10-27",
    StudyLevel: "SMA",
    category: "Sumo Robot",
    Note: "1st Winner Of Sumo Game Competition",
  },
  {
    number: "20/IITC/X/2024",
    name: "Alwan Abqory Winesa",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Sumo Robot",
    Note: "2nd Winner Of Sumo Game Competition",
  },
  {
    number: "20/IITC/X/2024",
    name: "Azam Zahran Razzaq",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Sumo Robot",
    Note: "2nd Winner Of Sumo Game Competition",
  },
  {
    number: "25/IITC/X/2024",
    name: "Rachmat Fadhilah Sumpena",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Sumo Robot",
    Note: "3rd Winner Of Sumo Game Competition",
  },
  {
    number: "25/IITC/X/2024",
    name: "Ahmad Zaky Aiman",
    date: "2024-10-27",
    StudyLevel: "SMP",
    category: "Sumo Robot",
    Note: "3rd Winner Of Sumo Game Competition",
  },
];
